/** Copyright (c) 2019 T. Rowe Price. All rights reserved. */

import Cleave from 'cleave.js';
import { func, string } from 'prop-types';
import React from 'react';

const inputFormatOptions = {
  ssn: {
    blocks: [3, 2, 4],
    delimiter: '-',
    numericOnly: true
  },
  tin: {
    blocks: [2, 7],
    delimiter: '-',
    numericOnly: true
  },
  'country-code': {
    blocks: [3],
    numericOnly: true
  },
  'non-us': {
    blocks: [12],
    numericOnly: true
  },
  us: {
    blocks: [3, 3, 4],
    delimiter: '-',
    numericOnly: true
  },
  ext: {
    blocks: [5],
    numericOnly: true
  },
  birthday: {
    date: true,
    delimiter: '/',
    datePattern: ['m', 'd', 'Y']
  },
  'challenge-deposit': {
    numeral: false,
    numeralPositiveOnly: true,
    numeralIntegerScale: 2,
    numericOnly: true,
    blocks: [5],
    prefix: '$0.',
    rawValueTrimPrefix: true,
    delimiter: '-', // allows prefix to have '.'
    numeralDecimalMark: ',' // allows prefix to have '.'
  },
  otpToken: {
    numericOnly: true,
    blocks: [6]
  }
};

class FormattedInput extends React.Component {
  constructor(props) {
    super(props);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleInputRefChange = this.handleInputRefChange.bind(this);
    this.handleOnBlur = this.handleOnBlur.bind(this);
  }

  componentDidUpdate(prevProps) {
    const { format, value } = this.props;
    if (format !== prevProps.format || value !== prevProps.value) {
      this.cleaveInstance.destroy();
      this.handleInputRefChange(this.inputRef);
    }
  }

  cleaveInstance;
  inputRef;

  handleInputRefChange(ref) {
    this.inputRef = ref;

    if (!ref) {
      if (this.cleaveInstance) {
        this.cleaveInstance.destroy();
      }
      return;
    }

    const { format, value } = this.props;

    const options = inputFormatOptions[format];
    options.onValueChanged = this.handleInputChange;
    this.cleaveInstance = new Cleave(ref, options);
    this.cleaveInstance.setRawValue(value);
  }

  handleInputChange(event) {
    if (event.persist) {
      event.persist();
    }
    const { format, onChange } = this.props;
    const value = event.target.value;
    const options = inputFormatOptions[format];
    const { delimiter } = options;
    let cleanedValue = value;
    while (cleanedValue.indexOf(delimiter) !== -1) {
      cleanedValue = cleanedValue.replace(delimiter, '');
    }
    if (onChange) {
      onChange(cleanedValue);
    }
  }

  handleOnBlur() {
    const { onBlur } = this.props;
    if (onBlur) {
      onBlur();
    }
  }

  render() {
    const {
      className,
      dataTestId = '',
      disable,
      placeholder = '',
      name,
      id,
      value
    } = this.props;

    return (
      <input
        className={className}
        data-testid={dataTestId}
        id={id}
        value={value ? value : placeholder}
        ref={this.handleInputRefChange}
        onBlur={this.handleOnBlur}
        placeholder={placeholder}
        disabled={disable}
        name={name}
      />
    );
  }
}

FormattedInput.propTypes = {
  className: string.isRequired,
  format: string.isRequired,
  placeholder: string,
  onChange: func,
  onBlur: func,
  value: string
};

FormattedInput.defaultProps = {
  value: ''
};

export default FormattedInput;
